import "./DownloadApp.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faApple,
  faGooglePlay,
  faAndroid,
} from "@fortawesome/free-brands-svg-icons";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom"

const images = [
  {
    url: "news1.png",
    date: "June 25 2025",
    caption: "Altoracapital Whales Bash in Barcelona",
  },
  {
    url: "news2.png",
    date: "June 20 2025",
    caption: "Explore Future Finance",
  },
  {
    url: "news3.png",
    date: "May 20 2025",
    caption: "Whale's Rave: Arcadia",
  },
  {
    url: "news4.png",
    date: "May 15 2025",
    caption: "Whale's Rave: Rivers",
  },
  {
    url: "news5.png",
    date: "May 12 2025",
    caption: "Title Sponsor of TOKEN2049",
  },
];
const DownloadApp = () => (
  <section>
    <section className="explore-section mt-5 mb-5">
      <div className="container">
        <div className="row align-items-center mb-2">
          <div className="col-7 col-md-8">
            <h3 className="explore-title">EXPLORE FUTURE FINANCE</h3>
          </div>
          <div className="col-5 col-md-4 text-end">
            <Link to="/login" className="text-white explore-view-more">
              View More <FontAwesomeIcon icon={faChevronRight} />
            </Link>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 col-lg-12">
            <div className="row g-3">
              {/* Left: Big image */}
              <div className="col-12 col-md-4 g-4">
                <div className="explore-img-wrapper explore-img-big h-100">
                  <img src={require('../images/'+images[1].url)} alt="explore 1" />
                  <div className="explore-overlay explore-date">
                    {images[0].date}
                  </div>
                  <div className="explore-overlay explore-caption h1 fw-bold fs-4">
                    {images[0].caption}
                  </div>
                </div>
              </div>
              {/* Right: 2x2 grid */}
              <div className="col-12 col-md-8">
                <div className="row  h-100">
                  <div className="col-md-8 col-6 d-flex g-4">
                    <div className="explore-img-wrapper explore-img-small flex-fill">
                      <img src={require('../images/'+images[1].url)} alt="explore 2" />
                      <div className="explore-overlay explore-date">
                        {images[1].date}
                      </div>
                      <div className="explore-overlay explore-caption h1 fw-bold fs-4">
                        {images[1].caption}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-6 d-flex g-4">
                    <div className="explore-img-wrapper explore-img-small flex-fill">
                      <img src={require('../images/'+images[2].url)} alt="explore 3" />
                      <div className="explore-overlay explore-date">
                        {images[2].date}
                      </div>
                      <div className="explore-overlay explore-caption h1 fw-bold fs-4">
                        {images[2].caption}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-6 d-flex g-4">
                    <div className="explore-img-wrapper explore-img-small flex-fill">
                      <img src={require('../images/'+images[3].url)} alt="explore 4" />
                      <div className="explore-overlay explore-date">
                        {images[3].date}
                      </div>
                      <div className="explore-overlay explore-caption h1 fw-bold fs-4">
                        {images[3].caption}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-8 col-6 d-flex g-4">
                    <div className="explore-img-wrapper explore-img-small flex-fill">
                      <img src={require('../images/'+images[4].url)} alt="explore 5" />
                      <div className="explore-overlay explore-date">
                        {images[4].date}
                      </div>
                      <div className="explore-overlay explore-caption h1 fw-bold fs-4">
                        {images[4].caption}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="mb-4">
      <div className="container">
        <div className="d-flex align-items-center justify-content-center">
          <h1 className="text-uppercase text-center mb-5 fw-bolder display-4 " style={{maxWidth:'900px'}}>
            Worldwide Buzz Media on Our Narrative
          </h1>
        </div>
        <div className="row">
          <div className="col-md-4 g-5">
            <div className="card bg-black text-white border-1 border-secondary rounded-4 p-3 pt-5 pb-5">
              <div className="card-body"></div>
              <h4 className="fw-bold mt-3 mb-0">
                Altoracapital futures performance rivals top exchanges across{" "}
              </h4>
              <p className="card-text text-secondary mt-3 fw-semibold">
                Altoracapital futures performance rivals top exchanges across the
                globe, offering a seamless trading experience with advanced
                features and competitive fees.
              </p>
            </div>
          </div>
          <div className="col-md-4 g-5">
            <div className="card bg-black text-white border-1 border-secondary rounded-4 p-3 pt-5 pb-5">
              <div className="card-body"></div>
              <h4 className="fw-bold mb-0 mt-3">
                Altoracapital futures performance rivals top exchanges across{" "}
              </h4>
              <p className="card-text text-secondary mt-3 fw-semibold">
                Altoracapital futures performance rivals top exchanges across the
                globe, offering a seamless trading experience with advanced
                features and competitive fees.
              </p>
            </div>
          </div>
          <div className="col-md-4 g-5">
            <div className="card bg-black text-white border-1 border-secondary rounded-4 p-3 pt-5 pb-5">
              <div className="card-body"></div>
              <h4 className="fw-bold mb-0 mt-3">
                Altoracapital futures performance rivals top exchanges across{" "}
              </h4>
              <p className="card-text text-secondary mt-3 fw-semibold">
                Altoracapital futures performance rivals top exchanges across the
                globe, offering a seamless trading experience with advanced
                features and competitive fees.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
);

export default DownloadApp;
